<div class="columns">
  <div class="column is-3"></div>
  <div class="column is-6">
    <div class="card has-round-border m-auto p-2 has-box-shadow">
        <form (submit)="login()">
          <div class="title is-4 is-uppercase has-text-centered is-bold color-darkblue pt-2 mb-1">Anmelden</div>
          <app-notification *ngIf="loginError" error="true" display="true" timeOut="0" (notificationClosed)="loginError = false"  content="Dein Nutzername und/oder Passwort ist fehlerhaft"></app-notification>
          <div class="is-flex is-flex-direction-column is-align-items-center">

              <div *ngIf="logins && hasLogins()" class="select-wrapper is-width-9">
                <select [(ngModel)]="credentials.username" name="userName" class="dropdown has-round-border has-box-shadow color-darkblue no-border no-outline">
                  <option value="" selected disabled>Niederlassung wählen</option>
                  <option *ngFor="let login of logins" value="{{login.mail}}">
                    {{login.standort}}
                  </option>
                </select>
              </div>

            <input *ngIf="!hasLogins()" id="username" name="userName"
                   class="border-input form-input"
                   placeholder="E-Mail Adresse" [(ngModel)]="credentials.username"/>

            <input id="password" name="password" type="password" class="border-input form-input" placeholder="Passwort"
                   [(ngModel)]="credentials.password"/>

            <button data-cy="submit-login" type="submit" class="button has-background-lightblue buy-button is-size-7 has-round-border mt-2 button-login">
              <p class="is-bold is-uppercase is-size-6">Login</p>
            </button>

            <a class="color-lightblue mt-4" routerLink="/password-forgotten">Passwort vergessen?</a>
            <hr class="mt-3 mb-3 is-width-7">
            <a class="color-lightblue" (click)="showContactSupportModal = true">Jetzt einen Zugang anfragen!</a>
          </div>
        </form>
    </div>

    <p class="has-text-centered is-up color-darkblue is-size-5 mt-5">Einfach. Online. Digital</p>
  </div>
  <div class="column is-3"></div>
</div>

<app-contact-overlay [isRegisterComponent]="true" (modalClosed)="showContactSupportModal=false" *ngIf="showContactSupportModal"
                     [displayed]="showContactSupportModal"></app-contact-overlay>
